<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.machine.change_owner_title')" :externaltrigger="dialogtrigger"
      :externalCloseTrigger="closetrigger">

      <template v-slot:content>
        <v-container :key="dialogtrigger">
          <v-alert type="info" prominent dense>
            {{ $t('servicesystem.common_objects.machine.change_owner_info') }}
          </v-alert>
          <v-row align="center" no-gutters class="mb-4">
            <v-col cols="auto">
              <div class="ml-2" style="width: 35px;"></div>
            </v-col>
            <v-col cols="0">
              <MachineSelect :value="machineId" disabled>
              </MachineSelect>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters class="mb-4">
            <v-col cols="auto">
              <div class="ml-2 pt-3" style="width: 35px;">{{ $t('servicesystem.from') }}</div>
            </v-col>
            <v-col cols="0">
              <CustomerSelect :value="currentCustomerId" disabled>
              </CustomerSelect>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters class="mb-10">
            <v-col cols="auto">
              <div class="ml-2 pt-3" style="width: 35px;">{{ $t('servicesystem.to') }}</div>
            </v-col>
            <v-col cols="0">
              <CustomerSelect v-model="customerId" externaledit>
              </CustomerSelect>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click=" closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn @click="customerId ? save() : null" :disabled="!customerId"
          :color="customerId ? 'tertiary' : 'disabled'" dark>{{ $t('servicesystem.common_objects.machine.change_owner') }}</v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import MachineSelect from "@/components/Inputs/EntityDropdowns/MachineSelect2.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "ChangeMachineOwnerDialog",
  props: {
    externaltrigger: Number,
    machineId: [Number, String],
    currentCustomerId: String,
  },
  components: {
    SlottedDialog,
    CustomerSelect,
    MachineSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      customerId: null,
      valid: false,
      loading: false,
    };
  },

  mounted() { },

  methods: {
    save() {
      this.changeOwnerOnMachine(this.machineId, this.customerId)
        .then((response) => {
          response.new = true;
          this.$emit("Update", response);
          this.$router.push({ query: { timestamp: this.getNowTime(this.oldTimeFormat) } });
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },

  },

  computed: {

  },

  watch: {
    externaltrigger: function () {
      this.customerId = null;
      this.dialogtrigger++;
    },
  },
};
</script>